import script from "./activity-upload-file.vue?vue&type=script&lang=tsx&setup=true"
export * from "./activity-upload-file.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__